module.exports = __webpack_public_path__ + "img/PAMMAccountLogo1.d12f7559.svg";